import { render, staticRenderFns } from "./CardPlan.vue?vue&type=template&id=04fb5372&scoped=true"
import script from "./CardPlan.vue?vue&type=script&lang=js"
export * from "./CardPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fb5372",
  null
  
)

export default component.exports